export default {"src":"/_next/static/image/public/images/flags/flag_355.ca12890e3b5d0ced35b4a6bf410aaf8d.svg","height":16,"width":24};